import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useRegisterAdminAnnouncementBannerQuery, {
	type useRegisterAdminAnnouncementBannerQuery$data,
	type useRegisterAdminAnnouncementBannerQuery$variables,
} from './__generated__/useRegisterAdminAnnouncementBannerQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadAdminAnnouncementBanner = (): Promise<{
	data: useRegisterAdminAnnouncementBannerQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> =>
	query<
		useRegisterAdminAnnouncementBannerQuery$data,
		useRegisterAdminAnnouncementBannerQuery$variables
	>({
		query: useRegisterAdminAnnouncementBannerQuery,
	});
